import React from 'react'

type SpinnerProps = {
  size?: number
  color?: string
  className?: string
}

const Spinner = (props: SpinnerProps) => {
  const size = props.size ?? 20
  const childSize = (size * 64) / 80
  const borderSize = (size * 8) / 80
  return (
    <div className={`lds-ring ${props.className ?? ''}`} style={{width: size, height: size, color: props.color}}>
      <div
        style={{width: childSize, height: childSize, borderWidth: borderSize, borderColor: 'currentColor transparent transparent transparent'}}
      ></div>
      <div
        style={{width: childSize, height: childSize, borderWidth: borderSize, borderColor: 'currentColor transparent transparent transparent'}}
      ></div>
      <div
        style={{width: childSize, height: childSize, borderWidth: borderSize, borderColor: 'currentColor transparent transparent transparent'}}
      ></div>
      <div
        style={{width: childSize, height: childSize, borderWidth: borderSize, borderColor: 'currentColor transparent transparent transparent'}}
      ></div>
    </div>
  )
}

export default Spinner
